<template>
    <div class="media-share" dusk="media-share-component">
        <layout :is-loading="isLoading">

            <!-- active bread crumb //-->
            <template v-if="!isLoading" v-slot:breadcrumb>
                <li class="active"><span>{{ item.title }}</span></li>
            </template>

            <!-- Navbar actions //-->
            <template v-slot:navbar-right>
                <div v-show="selectedCount > 0" class="btn-group" id="select-multiple">
                    <button type="button" class="btn btn-default dropdown-toggle rounded-xl" id="with-selected" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="isLoading">
                        With selected <span v-if="selectedCount > 0" class="badge">{{ selectedCount }}</span> <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="with-selected-download" @click.prevent="doDownloadSelected(item.id)"><i class="fas fa-cloud-download"></i> Download</a>
                        </li>
                        <li>
                            <a class="with-selected-clear" @click.prevent="doClearSelected"><i class="fa fa-ban"></i> Clear selected</a>
                        </li>
                    </ul>
                </div>

                <a class="btn btn-primary navbar-btn rounded-xl px-5 media-share-download" :href="downloadAllURL">
                    <i class="fas fa-cloud-download mr-2"></i> Download all
                </a>
            </template>

            <!-- default slot (main) //-->
            <div class="container pt-5">

                <!-- Media sets //-->
                <template v-if="hasSets">
                    <h4 v-show="!isLoading" class="media-gallery-heading">Collections</h4>
                    <gallery item-classes="media-item-container col-xs-12 col-md-6 col-lg-4" :items="item.children.data" :pad-bottom="false">

                        <template #item="slotProps">
                            <media-item
                                :item="slotProps.mediaItem"
                                :item-route="{name: 'set-view', params: {id: item.id, set_id: slotProps.mediaItem.id}}"
                                condensed
                            >
                                <template #select="{ item }">
                                    <input type="checkbox" :id="`checkbox-${item.id}`" class="gallery-item-checkbox" v-model="selectedItems" :value="{item, size: getItemFilesize(item)}">
                                    <label class="gallery-item-checkbox-label" :for="`checkbox-${item.id}`"></label>
                                </template>

                                <template #meta="{ item }">
                                    <button class="btn btn-sm btn-default media-item-download hidden-ios" @click.prevent="doDownload(item)">
                                        <i class="fa fa-cloud-download"></i> Download
                                    </button>

                                </template>
                            </media-item>
                        </template>
                    </gallery>
                </template>

                <!-- Media items //-->
                <template v-if="hasMedia">
                    <hr v-if="hasSets">
                    <h4 v-show="!isLoading" class="media-gallery-heading">Media Items</h4>
                    <gallery v-if="hasItem" :items="item.media.data" item-classes="media-item-container col-xs-12 col-md-6 col-lg-4" :pad-bottom="false">
                        <template #item="slotProps">
                            <media-item
                                :item="slotProps.mediaItem"
                                :item-route="{name: 'media-view', params: {id: item.id, media_id: slotProps.mediaItem.id}}"
                            >

                                <template #select="{ item }">
                                    <input type="checkbox" :id="`checkbox-${item.id}`" class="gallery-item-checkbox" v-model="selectedItems" :value="{item, size: getItemFilesize(item)}">
                                    <label class="gallery-item-checkbox-label" :for="`checkbox-${item.id}`"></label>
                                </template>

                                <template #meta="{ item }">
                                    <button class="btn btn-sm btn-default media-item-download hidden-ios" @click.prevent="doDownload(item)">
                                        <i class="fa fa-cloud-download"></i> Download
                                    </button>
                                </template>
                            </media-item>
                        </template>
                    </gallery>
                </template>

            </div>
        </layout>
    </div>
</template>

<script>
import { formatBytes } from 'ca-js-helper';

// components
import Layout from './Layout';
import Gallery from '@/components/media/Gallery';
import MediaItem from '@/components/media/MediaItem';

// mixins
import common from '@/components/media/app/mixins/common';
import download from '@/components/media/app/mixins/download';

export default {
    name: 'MediaApp',
    mixins: [common, download],
    components: {
        Layout,
        Gallery,
        MediaItem,
    },
}
</script>
